import { CurrentItemType } from '@app/components/excluded-items/use-change-item-type';
import { SimpleDialog } from '@app/hooks/use-simple-dialog';
import { OperationReportTypeEnum } from '@shared/api/types';
import { Icons } from '@shared/components/content/icons';
import { Button } from '@shared/components/ui/button';
import { useState } from 'react';
import {
  UpdateItemRowDetails,
  UpdateItemsModalBody,
} from './update-items-modal-body';

interface UpdateItemButtonProps {
  /** The inventory item's uuid — a PurchasedGood or SoldGood per reportType. */
  itemUuid: string;
  /** The item's food-activity uuid, on activity-keyed (food) tables. */
  foodActivityUuid?: string;
  currentType: CurrentItemType;
  /** Row data shown as Original data and used to prefill the modal. */
  itemDetails?: UpdateItemRowDetails;
  /** Purchased vs sold endpoints; defaults to purchase. */
  reportType?: OperationReportTypeEnum;
}

/**
 * Per-row pencil button opening the same "Update items" modal the bulk action
 * bar uses, scoped to a single item.
 */
export function UpdateItemButton({
  itemUuid,
  foodActivityUuid,
  currentType,
  itemDetails,
  reportType,
}: UpdateItemButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        size="icon"
        variant="outline"
        aria-label="Update item"
        onClick={(event) => {
          event.stopPropagation();
          setOpen(true);
        }}
        icon={<Icons.pencil className="size-4" />}
      />
      <SimpleDialog
        open={open}
        setOpen={setOpen}
        header="Update item"
        // Wide enough for the three-column modelling row and pack-weight grid.
        contentClassName="max-w-4xl max-h-[90vh]"
        content={
          open ? (
            <UpdateItemsModalBody
              selectedUuids={[itemUuid]}
              selectedFoodActivityUuids={
                foodActivityUuid ? [foodActivityUuid] : undefined
              }
              selectedCount={1}
              currentType={currentType}
              itemDetails={itemDetails}
              reportType={reportType}
              onClose={() => setOpen(false)}
              onCompleted={() => setOpen(false)}
            />
          ) : (
            <></>
          )
        }
      />
    </>
  );
}
